/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  AvailableLanguagesField,
  AvailableSoftwaresField,
  MailAddressField,
  NameField,
  PortfolioField,
  QuestionField,
  ReasonField,
  ResumeField,
  SelfPrField,
  SkillSheetField,
  SocialNetworkUrlsField,
  TelField,
} from '~/form/components/organisms'
import validationRulesComposer from '~/form/libs/validationRulesComposer'
import type { Config } from '~/form/types'

const configs: Config[] = [
  {
    name: '氏名',
    component: NameField,
    props: {
      required: true,
    },
  },
  {
    name: 'メールアドレス',
    component: MailAddressField,
    props: {
      required: true,
    },
  },
  {
    name: 'あなたのことがわかるURL',
    component: SocialNetworkUrlsField,
    props: {},
  },
  {
    name: '履歴書',
    component: ResumeField,
    props: {},
  },
  {
    name: '話をききたい理由',
    component: ReasonField,
    props: {
      required: true,
      label: '話をききたい理由',
      placeholder:
        'この職種について気になる点や、話をききたい理由を具体的に詳しく、記入してください。',
    },
  },
]

export default configs

export const validators = validationRulesComposer(configs)
